import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../types';
import RuleSetAuditLogs from '../../../../../../../../views/DataUnification/RuleSetAuditLogs';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/audit/$id/')({
  component: RuleSetAuditLogs,
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      (!!context.userPermissions.hasAllowedPermission({
        path: PAGE_PATHS.DATA_UNIFICATION_FIELDS,
        permission: Permission.CREATE,
      }) ||
        !!context.userPermissions.hasAllowedPermission({
          path: PAGE_PATHS.DATA_UNIFICATION_FIELDS,
          permission: Permission.UPDATE,
        })) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
